import React from 'react';
import PropTypes from 'prop-types';

const ColorSquare = ({ color }) => (
  <div className="product-card__text__colors__color" style={{ backgroundColor: color }} />
);

ColorSquare.propTypes = {
  color: PropTypes.string.isRequired,
};

export default ColorSquare;



// WEBPACK FOOTER //
// ./src/components/ui/ProductCard/ColorSquare/index.js